import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [{
		path: '/login',
		component: () => import('@/views/login/index'),
		hidden: true
	},
	{
		path: '/404',
		component: () => import('@/views/404'),
		hidden: true
	},
	{
		path: '',
		component: Layout,
		redirect: '/storeManage',
		// children: [{
		// 	path: 'home',
		// 	name: 'home',
		// 	component: () => import('@/views/home/index'),
		// 	meta: {
		// 		title: '首页',
		// 		icon: 'home'
		// 	}
		// }]
	}
]

export const asyncRouterMap = [{
		path: '/storeManage',
		component: Layout,
		redirect: '/storeManage/list',
		name: 'admin:storeManage',
		meta: {
			title: '店铺管理',
			icon: 'store'
		},
		alwaysShow: true,
		children: [{
			path: 'list',
			name: 'admin:storeManage:list',
			component: () => import('@/views/storeManage/list'),
			meta: {
				title: '店铺管理',
				icon: 'product-list'
			}
		}]
	},
	{
		path: '/qualityManage',
		component: Layout,
		redirect: '/qualityManage/list',
		name: 'admin:qualityManage',
		meta: {
			title: '精品管理',
			icon: 'quality'
		},
		alwaysShow: true,
		children: [{
				path: 'list',
				name: 'admin:qualityManage:list',
				component: () => import('@/views/qualityManage/list'),
				meta: {
					title: '精品管理',
					icon: 'product-list'
				}
			},
			{
				path: 'examine',
				name: 'admin:qualityManage:examine',
				component: () => import('@/views/qualityManage/examine'),
				meta: {
					title: '精品审核',
					icon: 'product-add'
				}
			}
		]
	},
	// {
	// 	path: '/schedule',
	// 	component: Layout,
	// 	redirect: '/schedule/list',
	// 	name: 'admin:schedule',
	// 	meta: {
	// 		title: '任务管理',
	// 		icon: 'product'
	// 	},
	// 	alwaysShow: true,
	// 	children: [{
	// 			path: 'list',
	// 			name: 'admin:schedule:page',
	// 			component: () => import('@/views/schedule/list'),
	// 			meta: {
	// 				title: '定时任务列表',
	// 				icon: 'product-list'
	// 			}
	// 		},
	// 		{
	// 			path: 'log',
	// 			name: 'admin:schedule:log',
	// 			component: () => import('@/views/schedule/log'),
	// 			meta: {
	// 				title: '定时任务日志',
	// 				icon: 'product-add'
	// 			}
	// 		},
	// 		{
	// 			path: 'updateSchedule',
	// 			name: 'admin:schedule:add',
	// 			component: () => import('@/views/schedule/updateSchedule'),
	// 			meta: {
	// 				title: '更新定时任务',
	// 				icon: 'product-add'
	// 			},
	// 			hidden: true
	// 		}
	// 	]
	// },
	// {
	// 	path: '/adminUser',
	// 	component: Layout,
	// 	redirect: '/adminUser/list',
	// 	name: 'admin:admin',
	// 	meta: {
	// 		title: '系统用户',
	// 		icon: 'order'
	// 	},
	// 	alwaysShow: true,
	// 	children: [{
	// 			path: 'dept',
	// 			name: 'admin:dept:list',
	// 			component: () => import('@/views/adminUser/dept'),
	// 			meta: {
	// 				title: '部门管理',
	// 				icon: 'product-list'
	// 			}
	// 		},
	// 		{
	// 			path: 'list',
	// 			name: 'admin:admin:page',
	// 			component: () => import('@/views/adminUser/list'),
	// 			meta: {
	// 				title: '用户列表',
	// 				icon: 'product-list'
	// 			}
	// 		},
	// 		{
	// 			path: 'update',
	// 			name: 'admin:admin:add',
	// 			component: () => import('@/views/adminUser/update'),
	// 			meta: {
	// 				title: '更新系统用户',
	// 				icon: 'product-add'
	// 			},
	// 			hidden: true
	// 		}
	// 	]
	// },
	// {
	// 	path: '/role',
	// 	component: Layout,
	// 	redirect: '/role/list',
	// 	name: 'admin:role',
	// 	meta: {
	// 		title: '角色管理',
	// 		icon: 'sms'
	// 	},
	// 	alwaysShow: true,
	// 	children: [{
	// 			path: 'list',
	// 			name: 'admin:role:page',
	// 			component: () => import('@/views/role/list'),
	// 			meta: {
	// 				title: '角色列表',
	// 				icon: 'sms-flash'
	// 			}
	// 		},
	// 		{
	// 			path: 'update',
	// 			name: 'admin:role:add',
	// 			component: () => import('@/views/role/update'),
	// 			meta: {
	// 				title: '更新角色',
	// 				icon: 'product-add'
	// 			},
	// 			hidden: true
	// 		}
	// 	]
	// },
	// {
	// 	path: '/config',
	// 	component: Layout,
	// 	redirect: '/config/list',
	// 	name: 'admin:config',
	// 	meta: {
	// 		title: '配置管理',
	// 		icon: 'ums'
	// 	},
	// 	alwaysShow: true,
	// 	children: [{
	// 			path: 'list',
	// 			name: 'admin:config:page',
	// 			component: () => import('@/views/config/list'),
	// 			meta: {
	// 				title: '配置列表',
	// 				icon: 'ums-admin'
	// 			}
	// 		},
	// 		{
	// 			path: 'update',
	// 			name: 'admin:config:add',
	// 			component: () => import('@/views/config/update'),
	// 			meta: {
	// 				title: '更新',
	// 				icon: 'ums-admin'
	// 			},
	// 			hidden: true
	// 		}
	// 	]
	// },
	{
		path: '*',
		redirect: '/404',
		hidden: true
	}
]

export default new Router({
	// mode: 'history', //后端支持可开
	scrollBehavior: () => ({
		y: 0
	}),
	routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js